'use client';
import { usePathname } from 'next/navigation';
import SubHeader from '@/components/header/SubHeader';
import { getSourcePath } from '@/rewrites';
import { useEffect, useState } from 'react';

const ConditionalSubHeader = () => {
  const pathname = usePathname() ?? '';
  const [showSubHeader, setShowSubHeader] = useState(false);

  useEffect(() => {
    if (
      pathname === '/' ||
      pathname === getSourcePath('/profile') ||
      pathname === getSourcePath('/organization') ||
      pathname === getSourcePath('/subscription') ||
      pathname === getSourcePath('/invoice') ||
      pathname === getSourcePath('/agents') ||
      pathname === getSourcePath('/search-results') ||
      pathname.includes(getSourcePath('/blog'))
    ) {
      setShowSubHeader(false);
    } else {
      setShowSubHeader(true);
    }
  }, [pathname]);

  return showSubHeader ? <SubHeader /> : null;
};

export default ConditionalSubHeader;
